<template>
  <div class="mixin-place">
    <div class="title">
      <p>{{taskName}}组合陈列套餐配置</p>
      <el-button type="primary" v-if="type !== 'view'" plain size="medium" @click="isShowAddPlaceDesign = true">新增</el-button>
    </div>
    <div style="padding: 20px 20px;">
      <div class="place-content" v-if="selectDataList.length">
        <div class="place-item-title">
          <el-row>
            <el-col :span="type === 'view' ? 3 : 2">序号</el-col>
            <el-col :span="type === 'view' ? 5 : 3">套餐名称</el-col>
            <el-col :span="type === 'view' ? 8 : 6">堆箱信息</el-col>
            <el-col :span="type === 'view' ? 8 : 8">产品信息</el-col>
            <el-col :span="5" v-if="type !== 'view'">操作</el-col>
          </el-row>
        </div>
        <el-row class="place-item" v-for="(item,key) in selectedDataCurrentList" :key="key">
          <el-col :span="type === 'view' ? 3 : 2">{{item.sequenceFlag}}</el-col>
          <el-col :span="type === 'view' ? 5 : 3">
            <el-input v-model="item.defineName" :disabled="true" />
          </el-col>
          <el-col :span="type === 'view' ? 8 : 6">
            <div>
              <div
                v-if="item.stackType === '01'"
              >{{`${item.subBrandInfo.parentBrandName}-${item.subBrandInfo.abiBrandDisplayName}-${item.stackPackSize}`}}</div>

              <DesignDetail v-else :dataList="item.brandList" :row="item.row"></DesignDetail>
            </div>
          </el-col>
          <el-col :span="type === 'view' ? 8 : 8">
            <div v-for="(product, index) in item.tradePerfectScopeDetailList" :key="index">
              <div v-if="product.brandCode" class="product-info">
                {{
                `${product.brandName}-
                ${product.subBrandName}-
                ${product.volume}-
                ${product.multiPackSpec}-
                ${product.minDisplayQty}件-
                ${product.rowQty}面`
                }}
              </div>
            </div>
          </el-col>
          <el-col :span="5" v-if="type !== 'view'">
            <el-button type="danger" plain size="medium" :disabled="disabled" @click="remove(item.scopeDefineId)">移除</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="nothing" v-else>您暂未选择{{taskName}}组合陈列套餐</div>
      <div class="pagination" v-if="selectDataList.length">
        <el-pagination
          background
          :current-page.sync="selectPageInfo.currentPage"
          :page-size="selectPageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="selectDataList.length"
          @current-change="getSelectedDataCurrentList"
        ></el-pagination>
      </div>
      <el-dialog :visible="isShowAddPlaceDesign" :title="`选择${taskName}组合陈列套餐配置`" width="80%" :show-close="false">
        <div class="addplace-search">
          <el-input v-model="searchForm.name" clearable placeholder="套餐名称" />
          <el-select v-model="searchForm.stackPackSize" clearable placeholder="堆箱规格">
            <el-option :label="packSize" :value="packSize" v-for="(packSize,index) in stackPackSizeList" :key="index"></el-option>
          </el-select>
          <el-select v-model="searchForm.subBrand" clearable placeholder="子品牌">
            <el-option :label="subBrand" :value="subBrand" v-for="(subBrand,index) in subBrandList" :key="index"></el-option>
          </el-select>
          <el-button class="btn-red" @click="search">搜索</el-button>
          <el-button class="btn-reset" @click="reset">重置</el-button>
        </div>
        <div class="place-content" v-if="currentList.length">
          <div class="place-item-title">
            <el-row>
              <el-col :span="2">序号</el-col>
              <el-col :span="3">套餐名称</el-col>
              <el-col :span="6">堆箱信息</el-col>
              <el-col :span="8">产品信息</el-col>
              <el-col :span="5">
                <el-checkbox v-model="allSelectList[pageInfo.currentPage-1]" @change="handleCheckAllChange">全选</el-checkbox>
              </el-col>
            </el-row>
          </div>
          <el-row class="place-item" v-for="(item,index) in currentList" :key="index">
            <el-col :span="2">{{item.sequenceFlag}}</el-col>
            <el-col :span="3">
              <el-input v-model="item.defineName" :disabled="true" />
            </el-col>
            <el-col :span="6">
              <div
                v-if="item.stackType === '01'"
              >{{`${item.subBrandInfo.parentBrandName}-${item.subBrandInfo.abiBrandDisplayName}-${item.stackPackSize}`}}</div>

              <DesignDetail v-else :dataList="item.brandList" :row="item.row"></DesignDetail>
            </el-col>
            <el-col :span="8">
              <div v-for="(product, index) in item.tradePerfectScopeDetailList" :key="index">
                <div v-if="product.brandCode" class="product-info">
                  {{
                  `${product.brandName}-
                  ${product.subBrandName}-
                  ${product.volume}-
                  ${product.multiPackSpec}-
                  ${product.minDisplayQty}件-
                  ${product.rowQty}面`
                  }}
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <el-checkbox v-model="item.checked" @change="val=>handleCheckChange(val,item.scopeDefineId)"></el-checkbox>
            </el-col>
          </el-row>
        </div>
        <div class="pagination" v-if="currentList.length">
          <el-pagination
            background
            :current-page.sync="pageInfo.currentPage"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="tmpDataList.length"
            @current-change="getCurrentList"
          ></el-pagination>
        </div>
        <div class="nothing" v-else>无符合条件的配置</div>
        <div class="add-handle">
          <el-button @click="closeAddPlaceDesign(2)">取消</el-button>
          <el-button @click="closeAddPlaceDesign(1)" class="btn-red">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DesignDetail from '@/views/trade/perfect2022/components/perfect-design-detail'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedData: {
      type: Array,
      default: () => {
        return []
      }
    },
    taskName: {
      type: String,
      default: ''
    }
  },
  components: {
    DesignDetail
  },
  computed: {
    disabled () {
      return this.type === 'view'
    }
  },
  data () {
    return {
      searchForm: {
        name: '',
        stackPackSize: '',
        subBrand: ''
      },
      selectPageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      isShowAddPlaceDesign: false,
      selectedList: [],
      allSelectList: [],
      stackPackSizeList: [],
      subBrandList: [],
      currentList: [],
      selectDataList: [],
      selectStatus: [],
      selectedDataCurrentList: [],
      tmpDataList: []
    }
  },
  watch: {
    dataList () {
      if (!this.dataList) {
        return
      }
      // this.pageInfo.total = this.dataList.length
      this.tmpDataList = this.dataList
      this.selectDataList = []
      this.addCheckbox()
      this.getStackPackSize(this.dataList)
      this.getStackPackSizeList()
      this.getSubBrand()
      this.getCurrentList()
    },
    // selectDataList () {
    //   this.copyInit()
    // }
    selectedData () {
      if (!this.selectedData) {
        return
      }
      this.copyInit()
      this.getStackPackSize(this.selectDataList)
    }
  },
  created () {
    this.copyInit()
    this.getCurrentList()
  },
  methods: {
    copyInit () {
      this.selectDataList = this.selectedData
      this.getSelectedDataCurrentList()
      let list = []
      this.selectDataList.forEach(item => {
        list.push(item.scopeDefineId)
        this.dataList.forEach(dataListItem => {
          if (item.scopeDefineId === dataListItem.scopeDefineId) {
            this.$set(dataListItem, 'checked', true)
          }
        })
      })
      this.checkCheckAll()
      this.selectedList = list
    },
    // 拆分规格字符串
    getStackPackSize (data) {
      data.forEach(item => {
        let list = []
        list = item.stackPackSize.split('*')
        item.row = list[0]
        item.col = list[1]
      })
    },
    // 获取规格列表
    getStackPackSizeList () {
      this.stackPackSizeList = []
      this.dataList.forEach(item => {
        this.stackPackSizeList.push(item.stackPackSize)
      })
      this.stackPackSizeList = [...new Set(this.stackPackSizeList)].sort((a, b) => {
        return a.split('*')[0] - b.split('*')[0] || a.split('*')[1] - b.split('*')[1]
      })
    },
    // 获取子品牌列表
    getSubBrand () {
      this.subBrandList = []
      this.dataList.forEach(dataItem => {
        dataItem.tradePerfectScopeDetailList.forEach(item => {
          this.subBrandList.push(item.subBrandName)
        })
      })
      this.subBrandList = [...new Set(this.subBrandList)]
    },
    // 添加checked属性 记录选择框状态
    addCheckbox () {
      this.dataList.forEach(item => {
        this.$set(item, 'checked', false)
        this.allSelectList.push(false)
      })
    },
    // 获取当前分页列表
    getCurrentList () {
      let startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      let endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      this.currentList = this.tmpDataList.slice(startIndex, endIndex)
      this.checkCheckAll()
    },
    // 全选按钮
    handleCheckAllChange (val) {
      if (val) {
        this.currentList.forEach(item => {
          item.checked = true
          this.selectedList.push(item.scopeDefineId)
          this.selectedList = [...new Set(this.selectedList)]
        })
      } else {
        this.currentList.forEach(item => {
          item.checked = false
          let index = this.selectedList.findIndex((selectItem) => {
            return selectItem === item.scopeDefineId
          })
          this.selectedList.splice(index, 1)
        })
      }
    },
    // checkbox 选中处理
    handleCheckChange (val, scopeDefineId) {
      if (val) {
        this.selectedList.push(scopeDefineId)
      } else {
        let index = this.selectedList.findIndex((item) => {
          return item === scopeDefineId
        })
        this.selectedList.splice(index, 1)
      }
      this.checkCheckAll()
    },
    checkCheckAll () {
      if (this.currentList.length === 0) {
        return
      }
      // 当前页面全选 全选按钮为选中状态
      if (this.currentList.every(item => {
        return item.checked === true
      })) {
        this.allSelectList[this.pageInfo.currentPage - 1] = true
      } else {
        this.allSelectList[this.pageInfo.currentPage - 1] = false
      }
    },
    // 搜索
    search () {
      this.tmpDataList = this.dataList.filter(item => {
        let canReturn = true
        if (this.searchForm.name) {
          canReturn = canReturn && item.defineName.toLowerCase().indexOf(this.searchForm.name.toLowerCase()) !== -1
        }
        if (this.searchForm.stackPackSize) {
          canReturn = canReturn && (item.stackPackSize === this.searchForm.stackPackSize)
        }
        if (this.searchForm.subBrand) {
          canReturn = canReturn && item.tradePerfectScopeDetailList.some(detailItem => {
            if (detailItem.subBrandName === this.searchForm.subBrand) {
              return true
            }
          })
        }
        return canReturn
      })
      this.pageInfo.currentPage = 1
      this.getCurrentList()
      this.checkCheckAll()
    },
    // 关闭dialog
    closeAddPlaceDesign (val) {
      if (val === 1) {
        this.selectDataList = this.dataList.filter(item => {
          for (let i = 0; i < this.selectedList.length; i++) {
            if (item.scopeDefineId === this.selectedList[i]) {
              return item
            }
          }
        })
        this.getSelectedDataCurrentList()
        this.isShowAddPlaceDesign = false
        return
      }

      this.isShowAddPlaceDesign = false
    },
    // 移除
    remove (val) {
      let index = this.selectDataList.findIndex(item => {
        return item.scopeDefineId === val
      })
      this.selectDataList.splice(index, 1)
      this.getSelectedDataCurrentList()
      this.selectedList.splice(this.selectedList.findIndex(item => {
        return item === val
      }), 1)

      if (this.selectedList.length) {
        this.dataList.forEach(item => {
          for (let i = 0; i < this.selectedList.length; i++) {
            if (item.scopeDefineId === this.selectedList[i]) {
              this.$set(item, 'checked', true)
              break
            } else {
              this.$set(item, 'checked', false)
            }
          }
        })
      } else {
        this.dataList.forEach(item => {
          item.checked = false
        })
      }
      this.getSelectedDataCurrentList()
      this.getCurrentList()
      this.checkCheckAll()
    },
    getSelectedDataCurrentList () {
      let startIndex = this.selectPageInfo.pageSize * (this.selectPageInfo.currentPage - 1)
      let endIndex = this.selectPageInfo.pageSize * this.selectPageInfo.currentPage
      this.selectedDataCurrentList = this.selectDataList.slice(startIndex, endIndex)
      if (!this.selectedDataCurrentList.length && this.selectPageInfo.currentPage !== 1) {
        this.selectPageInfo.currentPage = this.selectPageInfo.currentPage - 1
        this.getSelectedDataCurrentList()
      }
    },
    reset () {
      this.searchForm = this.$options.data().searchForm
      this.search()
    },
    resetData () {
      this.selectedList = []
      this.selectDataList = []
    }

  }
}
</script>

<style lang="scss" scoped>
.el-button {
  width: 80px;
  height: 30px;
  padding: 0 20px;
}
::v-deep .el-checkbox__inner {
  width: 30px;
  height: 30px;
}
::v-deep .el-checkbox__inner::after {
  width: 10px;
  height: 19px;
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 7px;
  top: -1px;
}
.mixin-place {
  background-color: #fff;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: 20px 20px 0;
    p {
      font-weight: 700;
      margin: 0;
    }
    .el-button {
      width: 80px;
      // margin-right: 83px;
    }
  }
  .place-content {
    position: relative;
    border-bottom: 1px solid #cccccc;
  }
  .place-item-title {
    //   margin-top: 10px;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    background-color: #f5f5f5;
  }
  .place-item {
    text-align: center;
    padding: 30px 0;
    display: flex;
    align-items: center;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.add-handle {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
}
.addplace-search {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  ::v-deep .el-input__icon {
    line-height: 30px;
  }
  .el-input,
  .el-select {
    width: 110px;
    margin-right: 20px;
    &::v-deep .el-input__inner {
      height: 30px;
    }
  }
  .el-button {
    height: 30px;
    padding: 0 20px;
  }
}
.nothing {
  background-color: #fff;
  padding: 50px 0 60px;
  text-align: center;
  margin: 0 auto;
}
.product-info {
  margin: 20px 0;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
</style>
